import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AuthFacadeService } from 'ngpd-merceros-authentication-fe-components';
import { Observable } from 'rxjs';

import environment from '../../../../environments/environment';
import { LoggedUser } from '../../../interfaces/user.interface';
import { AuthService } from '../../../services/auth.service';
import actualYear from '../../constants/rights-reserved.constant';

@Component({
    selector: 'mapp-sidebar-footer',
    templateUrl: './sidebar-footer.component.html',
    styleUrls: ['./sidebar-footer.component.scss'],
    standalone: false,
})
export class SidebarFooterComponent implements OnInit {
    loggedIn$: Observable<boolean>;

    initials: string;

    userData: LoggedUser;

    actualYear = actualYear;

    readonly siteMapUrl = new URL('/site-map/', environment.externalAuthIssuer).toString();

    isAdminUser = false;

    /**
     *
     * @param _authFacade
     * @param _authService
     * @param cdRef
     */
    constructor(
        private _authFacade: AuthFacadeService,
        private _authService: AuthService,
        private cdRef: ChangeDetectorRef
    ) {
        this.loggedIn$ = this._authFacade.loggedIn$;
    }

    /**
     *
     */
    ngOnInit() {
        this._authService.getUserAsObservable().subscribe((user) => {
            if (user) {
                this.userData = user;
                this.initials =
                    this.getInitialsByName(this.userData) ||
                    this.getInitialsByEmail(this.userData) ||
                    'MM';
                localStorage.setItem('user-initials', this.initials);
                // Use centralized helper on AuthService to check admin access
                this.isAdminUser = this._authService.isAidaAdmin(user);
            }
        });
    }

    /**
     *
     */
    logout() {
        this._authService.logOut();
        this._authFacade.logout();
        localStorage.removeItem('aida_tips_shown');
        // sessionStorage.setItem('returnUrl', 'logout');

        // localStorage.clear();
        // window.location.href = environment.externalAuthIssuer;
    }

    /**
     *
     * @param firstName
     * @param lastName
     * @param userData
     * @returns The initials derived from the first and last name, or null if first name is not provided.
     */
    private getInitialsByName(userData: LoggedUser): string | null {
        const { firstName, lastName } = userData ?? {};

        if (!firstName) {
            return null;
        }

        const firstInitial = firstName.trim()[0].toUpperCase();
        const secondInitial = lastName ? lastName.trim()[0]?.toUpperCase() : '';

        return `${firstInitial}${secondInitial}`;
    }

    /**
     *
     * @param email
     * @param userData
     * @returns The initials derived from the email, or null if email is not provided.
     */
    private getInitialsByEmail(userData: LoggedUser): string {
        if (!userData.username) {
            return null;
        }

        const [firstName, lastName] = userData.username.split('@')[0].split('.');
        userData.firstName = firstName;
        userData.lastName = lastName;
        return this.getInitialsByName(userData);
    }

    /**
     *
     */
    goToConsultant(): void {
        window.open(
            'https://www.wrike.com/form/eyJhY2NvdW50SWQiOjE3OTA2NzIsInRhc2tGb3JtSWQiOjIwNDU2OH0JNDcwNzg5NTM3NjAzMAlhMDkyMjc3NDBlNGYwNWI4YTg0NTUyNjg4NTI5MjE0YzRjNzhhMjdmYzA5MmMyMDU1ZTNlNjk1NWFjZmM4YWQ0',
            '_blank'
        );
    }

    /**
     *
     */
    openCookiePreferences(): void {
        document.querySelector<HTMLElement>('#teconsent a, #teconsent button')?.click();
    }
}
